import {ProfileEndpointResponse} from '../../../../generated/types';

export type FetchProfileRequest = {
  audience: string;
  entryPoint: string;
  attemptNumber: number;
  requiresSession: boolean;
  livemode?: boolean;
  surfaceLoadId?: string;
  expectedMerchant?: string;
  expectedUser?: string;
};

export async function fetchProfile(
  supportFetch: typeof fetch,
  {
    audience,
    entryPoint,
    attemptNumber = 0,
    requiresSession = false,
    surfaceLoadId,
    expectedMerchant,
    expectedUser,
    livemode,
  }: FetchProfileRequest,
): Promise<ProfileEndpointResponse> {
  const query = new URLSearchParams();

  query.set('audience', audience);
  query.set('entrypoint', entryPoint);
  query.set('livemode', `${livemode}`);
  query.set('requires_session', `${requiresSession}`);
  query.set('attempt_number', `${attemptNumber}`);

  if (surfaceLoadId) {
    query.set('surface_load_id', surfaceLoadId);
  }

  if (expectedMerchant) {
    query.set('expected_merchant', expectedMerchant);
  }

  if (expectedUser) {
    query.set('expected_user', expectedUser);
  }

  return supportFetch(`/profile?${query}`).then((resp) => resp.json());
}
